import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
// Components
import Footer from '../../Components/Footer';
import Container from '../../Components/Container';
// Services
import { sendUserInformation } from '../../services/sendUserInformation';
// Images
import { GrFormNext } from 'react-icons/gr';
import imageAquino from '../../Images/EBooks/aquino.svg';
import imageEBooks from '../../Images/EBooks/ebooks.webp';
import logoOnlineLibrary from '../../Images/logo/logo_OlibBlack.svg';
import imageAquinoReading from '../../Images/EBooks/aquinoReading.svg';
// Styles
import './EBooks.css';
// Translate
import { useTranslation } from 'react-i18next';

const EBOOKS_URL = 'https://library.aquinasnetwork.com/ebooks';

const EBooks = () => {
	const { t } = useTranslation();
	const [sectionActive, setSectionActive] = useState(false);
	const isCanonicalDomain =
		window.location.origin === 'https://library.aquinasnetwork.com';

	useEffect(() => {
		if (!isCanonicalDomain) {
			window.location.replace(EBOOKS_URL);
		}
	}, [isCanonicalDomain]);

	// Slices
	const { user_email } = useSelector((state) => state.user);
	const { institutionCode } = useSelector((state) => state.institution);

	const handleClicEBooks = () => {
		sendUserInformation('EBooks', 'EBooks', user_email, institutionCode);
		const url =
			institutionCode === 'IHU'
				? 'https://ebooks7-24.com/?ed=446'
				: 'https://ebooks7-24.com/Stage.aspx';

		window.open(url, '_blank');
	};

	if (!isCanonicalDomain) {
		return null;
	}

	return (
		<div className='EBooks'>
			<Container className='EBooksContainer'>
				<Link to='/' className='logoOnlineLibrary'>
					<img src={logoOnlineLibrary} alt='logo Aquinas Network' />
				</Link>

				{sectionActive ? (
					<div className='EBooksInfo'>
						<div className='EBooksInfoText'>
							<img className='aquinoImage' src={imageAquino} alt='Aquino' />

							<h2>
								<b>{t('Welcomem to Olib')}</b>{' '}
								{t('You now have exclusive access to select books')}
							</h2>
							<p>{t('Access the best academic resources')}</p>
							<div className='optionButtons'>
								<button
									className='backButtonEBooks'
									onClick={() => setSectionActive(false)}
								>
									{t('Skip')}
								</button>
								<button className='nextButtonEBooks' onClick={handleClicEBooks}>
									{t('Go to EBooks')}
									<GrFormNext />
								</button>
							</div>
						</div>
						<img className='imageEBooks' src={imageEBooks} alt='Ebooks' />
					</div>
				) : (
					<div className='EBooksInitial'>
						<img src={imageAquinoReading} alt='Aquino reading Network' />
						<h2>
							<b>{t('Welcomem to Olib')}</b> {t('Explore our eBooks')}
						</h2>
						<p>{t('Click Next')}</p>
						<button
							className='nextButtonEBooks'
							onClick={() => setSectionActive(true)}
						>
							{t('Next')} <GrFormNext />
						</button>
					</div>
				)}
			</Container>
			<Footer allContent={false} />
		</div>
	);
};

export default EBooks;
